import { NavLink } from "react-router-dom";

import { SubNavCobrancaGestaoDeCadastros } from "./subnavs/GestaoCobCadastros";

import { useUserInfor } from "../../../Context/User/";
import { SubNavGestaoCobAtendimentos } from "./subnavs/GestaoCobAtendimentos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import { ACESSOS } from "../../../Routes/Acessos";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoCobRelatorios } from "./subnavs/GestaoCobRelatorios";
import { SubNavMenuFinanceiroCobranca } from "./subnavs/MenuFinanceiro";

export default function CobrancaTab() {
    const { UserInfor } = useUserInfor();

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="CobrancaTab">
            <div
                id="kt_header_menu2"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {/* {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.DASHBOARD.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.COBRANCA.TELAS.DASHBOARD.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Dashboard</span>
                            </NavLink>
                        </li>
                    )} */}
                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.GESTAO_CLIENTES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.COBRANCA.TELAS.GESTAO_CLIENTES
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Clientes
                                </span>
                            </NavLink>
                        </li>
                    )}

                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.COBRANCA.TELAS.FILA_ATENDIMENTOS.ID_TELA,
                            ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.TODOS
                                .ID_TELA,
                            ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.USUARIO
                                .ID_TELA,
                            ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.GRUPO
                                .ID_TELA,
                        ]}
                    >
                        <SubNavGestaoCobAtendimentos />
                    </SubNavDropDown>
                    <SubNavDropDown
                        title={"Gestão de Cadastros"}
                        telas={[
                            ACESSOS.COBRANCA.MODAIS.CLASSIFICACAO_COBRANCA
                                .ID_TELA,
                            ACESSOS.COBRANCA.MODAIS.OBRA_COBRANCA.ID_TELA,
                            ACESSOS.COBRANCA.MODAIS.MOTIVO_INADIMPLENCIA
                                .ID_TELA,
                            ACESSOS.COBRANCA.MODAIS.RESULTADO_CONTATO.ID_TELA,
                        ]}
                    >
                        <SubNavCobrancaGestaoDeCadastros />
                    </SubNavDropDown>

                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.GESTAO_ACORDOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.COBRANCA.TELAS.GESTAO_ACORDOS
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Acordos
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.RENEGOCIACAO_GRUPO.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.COBRANCA.TELAS.RENEGOCIACAO_GRUPO
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Renegociação de Grupo
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.DISTRIBUICAO_CARTEIRA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.COBRANCA.TELAS.DISTRIBUICAO_CARTEIRA
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Contratos
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.TRIAGEM.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.COBRANCA.TELAS.TRIAGEM.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Triagem</span>
                            </NavLink>
                        </li>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.COBRANCA.TELAS.GESTAO_TITULOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.COBRANCA.TELAS.GESTAO_TITULOS
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Títulos
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Financeiro"}
                        telas={[ACESSOS.COBRANCA.TELAS.SERASA.ID_TELA]}
                    >
                        <SubNavMenuFinanceiroCobranca />
                    </SubNavDropDown>

                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[
                            ACESSOS.COBRANCA.TELAS.CAPYS_BI.ID_TELA,
                            ACESSOS.COBRANCA.TELAS.RELATORIO_CONTATO.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoCobRelatorios />
                    </SubNavDropDown>
                </ul>
            </div>
        </div>
    );
}
